module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.c05f2fa3.svg";